// extracted by mini-css-extract-plugin
module.exports = {"chat":"therapist_chat__1DjVq","scrollable":"therapist_scrollable__3fneq","article":"therapist_article__hUlI0","smallprint":"therapist_smallprint__16IMh"};